import config from '@src/config';
import moment from 'moment';

export const currentMessage = (propertyName: string) => {
  const messages: Array<{text: string; startDate?: string; endDate?: string}> = config[propertyName];
  const currentMoment = moment();
  const messageToShow = messages.filter((m) => m.startDate && currentMoment.isBetween(m.startDate, m.endDate));
  return messageToShow.length > 0 ? messageToShow[0].text : null;
};
